import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const emailValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const pattern = /^[a-zA-Z0-9._%-]+@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/;
  const valid = pattern.test(control.value);
  return valid ? null : { email: true };
};
